import React, { useEffect, useState } from "react";
import api from "../services/api";

function AdminList({ setPage }) {

const [admins,setAdmins] = useState([]);
const [search,setSearch] = useState("");

useEffect(()=>{
loadAdmins();
},[]);

/* LOAD ADMINS */

const loadAdmins = async () => {

try{

const res = await api.get("/admins");

setAdmins(res.data.data || []);

}catch(err){

console.log("Admin load error",err);

}

};

/* DELETE ADMIN */

const deleteAdmin = async (id) => {

if(!window.confirm("Delete this admin?")) return;

try{

await api.delete(`/admins/${id}`);

loadAdmins();

}catch(err){

console.log(err);

alert("Failed to delete admin");

}

};

/* FILTER */

const filteredAdmins = admins.filter(a => {

const text = search.toLowerCase();

return(
(a.email && a.email.toLowerCase().includes(text)) ||
(a.mobile && a.mobile.includes(text))
);

});

return(

<div style={{padding:"30px"}}>

{/* PAGE HEADER */}

<div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>

<h2>Admins</h2>

<button
style={primaryBtn}
onClick={()=>setPage({page:"add-admin"})}
>
+ Add New
</button>

</div>

{/* SEARCH */}

<div style={card}>

<h3>Search Admins</h3>

<input
placeholder="Search by Email or Mobile"
value={search}
onChange={(e)=>setSearch(e.target.value)}
style={input}
/>

</div>

{/* ADMIN LIST */}

<div style={card}>

<div style={{display:"flex",justifyContent:"space-between"}}>

<h3>Admins List</h3>

<span>Total: {filteredAdmins.length}</span>

</div>

<table style={table}>

<thead>

<tr>
<th style={th}>Name</th>
<th style={th}>Email</th>
<th style={th}>Industries</th>
<th style={th}>Products</th>
<th style={thCenter}>Status</th>
<th style={thCenter}>Actions</th>
</tr>

</thead>

<tbody>

{filteredAdmins.map((admin)=>(
<tr key={admin.id}>

<td style={td}>
{admin.first_name} {admin.last_name}
</td>

<td style={td}>{admin.email}</td>

<td style={td}>
{admin.industries && admin.industries.length > 0
  ? admin.industries.map(i => i.name).join(", ")
  : "-"
}
</td>

<td style={td}>
{[
  admin.products?.lms ? "LMS" : null,
  admin.products?.live ? "LIVE" : null
].filter(Boolean).join(" + ") || "-"}
</td>

<td style={td}>
<span style={
admin.status === "active"
? activeBadge
: inactiveBadge
}>
{admin.status === "active" ? "Active" : "Inactive"}
</span>
</td>

<td style={tdCenter}>

<button
style={editBtn}
onClick={()=>setPage({page:"edit-admin",adminId:admin.id})}
>
Edit
</button>

<button
style={deleteBtn}
onClick={()=>deleteAdmin(admin.id)}
>
Delete
</button>



</td>

</tr>
))}

</tbody>

</table>

</div>

</div>

);

}

/* UI */

const card = {
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"25px"
};

const input = {
width:"100%",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const table = {
width:"100%",
borderCollapse:"collapse",
marginTop:"15px"
};

const primaryBtn = {
background:"#2c3e50",
color:"#fff",
border:"none",
padding:"10px 16px",
borderRadius:"6px",
cursor:"pointer"
};

const editBtn = {
background:"#f39c12",
color:"#fff",
border:"none",
padding:"6px 10px",
borderRadius:"4px",
marginRight:"6px",
cursor:"pointer"
};

const deleteBtn = {
background:"#e74c3c",
color:"#fff",
border:"none",
padding:"6px 10px",
borderRadius:"4px",
cursor:"pointer"
};

const activeBadge = {
background:"#27ae60",
color:"#fff",
padding:"4px 10px",
borderRadius:"4px"
};

const inactiveBadge = {
background:"#e74c3c",
color:"#fff",
padding:"4px 10px",
borderRadius:"4px"
};


const th = {
textAlign:"left",
padding:"12px",
borderBottom:"1px solid #eee"
};

const thCenter = {
textAlign:"center",
padding:"12px",
borderBottom:"1px solid #eee"
};

const td = {
padding:"12px",
borderBottom:"1px solid #eee"
};

const tdCenter = {
padding:"12px",
textAlign:"center",
borderBottom:"1px solid #eee"
};
export default AdminList;